import { TableState, ActionType, TableInstance } from 'react-table';

import flow, { IdentityFn } from './flow';

export type StateReducer<D extends Record<string, unknown>> = {
  state: TableState<D>;
  action: ActionType;
  previousState: TableState<D>;
  instance?: TableInstance<D>;
};

export const createStateReducer =
  <D extends Record<string, unknown>>(
    ...handlers: IdentityFn<StateReducer<D>>[]
  ) =>
  (
    state: TableState<D>,
    action: ActionType,
    previousState: TableState<D>,
    instance?: TableInstance<D>
  ): TableState<D> => {
    return flow<StateReducer<D>>(handlers)({
      state,
      action,
      previousState,
      instance,
    }).state;
  };
